import { Component, AfterViewInit } from '@angular/core';
import { ExportCustomersService } from 'src/app/services/export.service';

@Component({
  selector: 'app-export-modal',
  templateUrl: './export-modal.component.html',
  styleUrls: ['./export-modal.component.scss']
})
export class ExportModalComponent implements AfterViewInit {
  constructor(private exportCustomers: ExportCustomersService) {}

  ngAfterViewInit(): void {
    this.exportCustomers.init();
  }

}
